





































































































































































































import {Component, Vue} from "vue-property-decorator";
import {TimeAssistant} from "@/entity/TimeAssistant";
import {SecurityUtils} from "@/oauth/SecurityUtils";
import {TimeAssistantDto} from "@/dto/TimeAssistantDto";
import {UserDto} from "@/oauth/UserDto";
import {TimeAssistantCollaborator} from "@/entity/TimeAssistantCollaborator";
import {TimeAssistantCollaboratorDto} from "@/dto/TimeAssistantCollaboratorDto";

@Component({
  components: {},
})

export default class AllTimeAssistant extends Vue {
  // timeAssistants: TimeAssistant[] = [];
  stopTimeAssistants: TimeAssistant[] = [];
  startTimeAssistants: TimeAssistant[] = [];
  finishTimeAssistants: TimeAssistant[] = [];
  su = SecurityUtils;
  tab = 'mails';
  timeAssistantCollaborator1 = new TimeAssistantCollaborator();

  static formatDate(timeStamp: number) {
    //三目运算符
    const Dates = new Date(timeStamp);
    //年份
    const Year: number = Dates.getFullYear();
    //月份下标是0-11
    const Months: any = (Dates.getMonth() + 1) < 10 ? '0' + (Dates.getMonth() + 1) : (Dates.getMonth() + 1);
    //具体的天数
    const Day: any = Dates.getDate() < 10 ? '0' + Dates.getDate() : Dates.getDate();
    //小时
    const Hours = Dates.getHours() < 10 ? '0' + Dates.getHours() : Dates.getHours();
    //分钟
    const Minutes = Dates.getMinutes() < 10 ? '0' + Dates.getMinutes() : Dates.getMinutes();
    //秒
    const Seconds = Dates.getSeconds() < 10 ? '0' + Dates.getSeconds() : Dates.getSeconds();
    //返回数据格式
    return Year + '/' + Months + '/' + Day;
  }

  async mounted() {
    const data1 = new Date();//现在时间戳
    const timeAssistantCollaborator1 = new TimeAssistantCollaborator();
    timeAssistantCollaborator1.username = this.su.getLoginUser().username;
    const timeAssistantCollaborators = await TimeAssistantCollaboratorDto.findAll(timeAssistantCollaborator1);//全部协作日程
    for (const value of timeAssistantCollaborators) {
      const timeAssistant = await TimeAssistantDto.findById(value.timeAssistantId);
      this.timeAssistantCollaborator1 = value;
      const data = new Date(timeAssistant.stopDate);//日程截止时间戳
      const user = await UserDto.findUser(timeAssistant.username);
      timeAssistant.timeAssistantComeFrom = user.name;
      timeAssistant.timeAssistantCollaborators = value;
      timeAssistant.isSelect = false;
      if (value.isFinish === true) {
        // if (data <= data1) {
        //   this.stopTimeAssistants.push(value);//逾期但完成了
        // }else {
        this.finishTimeAssistants.push(timeAssistant);//完成
        // }
      } else if (data <= data1) {
        this.stopTimeAssistants.push(timeAssistant);//逾期
      } else {
        this.startTimeAssistants.push(timeAssistant);//进行中
      }
    }
  }

}
